module.exports = __webpack_public_path__ + "static/media/search1.7676ee5a.svg";